import { render, staticRenderFns } from "./IntegrationTabWrapper.vue?vue&type=template&id=0cfd1dc2&scoped=true&"
import script from "./IntegrationTabWrapper.vue?vue&type=script&lang=js&"
export * from "./IntegrationTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationTabWrapper.vue?vue&type=style&index=0&id=0cfd1dc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfd1dc2",
  null
  
)

export default component.exports